const textOperators = [
  { value: "equals", label: "Равно" },
  { value: "not_equals", label: "Не равно" },
  { value: "contains", label: "Содержит" },
  { value: "not_contains", label: "Не содержит" }
];

const numberOperators = [
  { value: "equals", label: "Равно" },
  { value: "not_equals", label: "Не равно" },
  { value: "greater_than", label: "Больше" },
  { value: "greater_or_equal", label: "Больше или равно" },
  { value: "less_than", label: "Меньше" },
  { value: "less_or_equal", label: "Меньше или равно" }
];

const dateOperators = [
  { value: "equals", label: "В эту дату" },
  { value: "before", label: "Раньше даты" },
  { value: "after", label: "Позже даты" },
  { value: "on_or_before", label: "Не позже даты" },
  { value: "on_or_after", label: "Не раньше даты" }
];

export default function PersonalMenusPage({
  customMenus,
  templateColumns,
  actionColumns,
  directories,
  counterparties,
  users,
  addCustomMenu,
  updateCustomMenu,
  removeCustomMenu,
  addCustomMenuCondition,
  updateCustomMenuCondition,
  removeCustomMenuCondition
}) {
  const fields = [
    ...templateColumns.map((column) => ({
      id: column.id,
      label: column.label,
      format: column.format,
      key: column.key,
      options: getTemplateOptions(column, directories, counterparties)
    })),
    ...actionColumns.map((column) => ({
      id: column.id,
      label: column.label,
      format: "select",
      options: column.options.map((option) => option.value)
    }))
  ];

  const getField = (fieldId) => fields.find((field) => field.id === fieldId) || fields[0];

  const newCondition = () => {
    const field = fields[0];
    return {
      id: `cond_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`,
      fieldId: field?.id || "",
      operator: getOperators(field)[0].value,
      value: ""
    };
  };

  // Универсальная строка условия: onChange(patch), onRemove().
  const renderConditionRow = (condition, onChange, onRemove) => {
    const field = getField(condition.fieldId);
    const operators = getOperators(field);

    return (
      <div className="condition-row" key={condition.id}>
        <select
          value={condition.fieldId}
          onChange={(event) => {
            const nextField = getField(event.target.value);
            onChange({ fieldId: event.target.value, operator: getOperators(nextField)[0].value, value: "" });
          }}
        >
          {fields.map((item) => (
            <option key={item.id} value={item.id}>{item.label}</option>
          ))}
        </select>

        <select value={condition.operator} onChange={(event) => onChange({ operator: event.target.value })}>
          {operators.map((operator) => (
            <option key={operator.value} value={operator.value}>{operator.label}</option>
          ))}
        </select>

        {field?.options?.length > 0 ? (
          <select value={condition.value} onChange={(event) => onChange({ value: event.target.value })}>
            <option value="">Выберите значение</option>
            {field.options.map((option) => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
        ) : (
          <input
            type={field?.format === "date" ? "date" : "text"}
            inputMode={field?.format === "number" || field?.key === "amount" ? "decimal" : undefined}
            value={condition.value}
            onChange={(event) => onChange({ value: event.target.value })}
            placeholder="Значение"
          />
        )}

        <button onClick={onRemove}>Удалить</button>
      </div>
    );
  };

  // Мутации вкладок через updateCustomMenu(menuId, "tabs", nextTabs).
  const setTabs = (menu, nextTabs) => updateCustomMenu(menu.id, "tabs", nextTabs);
  const getTabs = (menu) => menu.tabs || [];

  const patchTab = (menu, tabId, patch) =>
    setTabs(menu, getTabs(menu).map((tab) => (tab.id === tabId ? { ...tab, ...patch } : tab)));

  const patchTabCondition = (menu, tabId, condId, patch) =>
    setTabs(menu, getTabs(menu).map((tab) =>
      tab.id === tabId
        ? { ...tab, conditions: (tab.conditions || []).map((c) => (c.id === condId ? { ...c, ...patch } : c)) }
        : tab
    ));

  return (
    <div>
      <div className="personal-menu-head">
        <div>
          <h1>Персональные меню</h1>
          <p>Создавайте меню с условиями по платежам и назначайте их конкретным пользователям.</p>
        </div>

        <button onClick={addCustomMenu}>Добавить меню</button>
      </div>

      <div className="personal-menu-list">
        {customMenus.map((menu) => {
          const tabs = getTabs(menu);

          return (
            <div className="personal-menu-card" key={menu.id}>
              <div className="personal-menu-title">
                <input
                  value={menu.label}
                  onChange={(event) => updateCustomMenu(menu.id, "label", event.target.value)}
                  placeholder="Название меню слева"
                />

                <button className="remove-column-btn" onClick={() => removeCustomMenu(menu.id)}>
                  Удалить меню
                </button>
              </div>

              <div className="personal-menu-section">
                <div className="personal-menu-section-head">
                  <strong>Вкладки</strong>
                  <span>У каждой вкладки свои условия. Вкладка без условий показывает всё.</span>
                </div>

                {tabs.map((tab) => (
                  <div className="menu-tab-edit" key={tab.id}>
                    <div className="menu-tab-edit-head">
                      <input
                        value={tab.label}
                        onChange={(event) => patchTab(menu, tab.id, { label: event.target.value })}
                        placeholder="Название вкладки"
                      />
                      <button
                        className="remove-column-btn"
                        onClick={() => setTabs(menu, tabs.filter((t) => t.id !== tab.id))}
                      >
                        Удалить вкладку
                      </button>
                    </div>

                    <div className="condition-list">
                      {(tab.conditions || []).map((condition) =>
                        renderConditionRow(
                          condition,
                          (patch) => patchTabCondition(menu, tab.id, condition.id, patch),
                          () => patchTab(menu, tab.id, {
                            conditions: (tab.conditions || []).filter((c) => c.id !== condition.id)
                          })
                        )
                      )}
                    </div>

                    <button
                      className="secondary-action-btn"
                      onClick={() => patchTab(menu, tab.id, { conditions: [...(tab.conditions || []), newCondition()] })}
                    >
                      Добавить условие вкладки
                    </button>

                    <div className="tab-sections">
                      <div className="personal-menu-section-head">
                        <strong>Разделы внутри вкладки</strong>
                        <span>Полосы-заголовки. Строки распределяются по условиям разделов.</span>
                      </div>

                      {(tab.sections || []).map((section) => {
                        const sections = tab.sections || [];
                        const setSections = (next) => patchTab(menu, tab.id, { sections: next });

                        return (
                          <div className="menu-section-edit" key={section.id}>
                            <div className="menu-tab-edit-head">
                              <input
                                value={section.label}
                                onChange={(event) =>
                                  setSections(sections.map((s) =>
                                    s.id === section.id ? { ...s, label: event.target.value } : s))}
                                placeholder="Название раздела"
                              />
                              <button
                                className="remove-column-btn"
                                onClick={() => setSections(sections.filter((s) => s.id !== section.id))}
                              >
                                Удалить раздел
                              </button>
                            </div>

                            <div className="condition-list">
                              {(section.conditions || []).map((condition) =>
                                renderConditionRow(
                                  condition,
                                  (patch) => setSections(sections.map((s) =>
                                    s.id === section.id
                                      ? { ...s, conditions: (s.conditions || []).map((c) => (c.id === condition.id ? { ...c, ...patch } : c)) }
                                      : s)),
                                  () => setSections(sections.map((s) =>
                                    s.id === section.id
                                      ? { ...s, conditions: (s.conditions || []).filter((c) => c.id !== condition.id) }
                                      : s))
                                )
                              )}
                            </div>

                            <button
                              className="secondary-action-btn"
                              onClick={() => setSections(sections.map((s) =>
                                s.id === section.id
                                  ? { ...s, conditions: [...(s.conditions || []), newCondition()] }
                                  : s))}
                            >
                              Добавить условие раздела
                            </button>
                          </div>
                        );
                      })}

                      <button
                        className="secondary-action-btn"
                        onClick={() => patchTab(menu, tab.id, {
                          sections: [...(tab.sections || []), { id: `sec_${Date.now()}`, label: "Новый раздел", conditions: [] }]
                        })}
                      >
                        Добавить раздел
                      </button>
                    </div>
                  </div>
                ))}

                <button
                  className="secondary-action-btn"
                  onClick={() =>
                    setTabs(menu, [...tabs, { id: `tab_${Date.now()}`, label: "Новая вкладка", conditions: [] }])
                  }
                >
                  Добавить вкладку
                </button>
              </div>

              <div className="personal-menu-section">
                <div className="personal-menu-section-head">
                  <strong>Общие условия меню</strong>
                  <span>Применяются ко всем вкладкам. Платеж должен соответствовать всем условиям.</span>
                </div>

                <div className="condition-list">
                  {menu.conditions.map((condition) =>
                    renderConditionRow(
                      condition,
                      (patch) => updateCustomMenuCondition(menu.id, condition.id, patch),
                      () => removeCustomMenuCondition(menu.id, condition.id)
                    )
                  )}
                </div>

                <button className="secondary-action-btn" onClick={() => addCustomMenuCondition(menu.id)}>
                  Добавить условие
                </button>
              </div>

              <div className="personal-menu-section">
                <div className="personal-menu-section-head">
                  <strong>Кто видит меню</strong>
                  <span>Выберите конкретных пользователей.</span>
                </div>

                <div className="personal-user-grid">
                  {users.map((user) => (
                    <label className="personal-user-option" key={user.id}>
                      <input
                        type="checkbox"
                        checked={(menu.userIds || []).includes(user.id)}
                        onChange={(event) => {
                          const currentIds = menu.userIds || [];
                          const nextIds = event.target.checked
                            ? [...new Set([...currentIds, user.id])]
                            : currentIds.filter((id) => id !== user.id);

                          updateCustomMenu(menu.id, "userIds", nextIds);
                        }}
                      />
                      <span>
                        <strong>{user.name}</strong>
                        <small>{user.username} · {user.role_label}</small>
                      </span>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          );
        })}

        {customMenus.length === 0 && (
          <div className="personal-menu-empty">Персональные меню еще не созданы.</div>
        )}
      </div>
    </div>
  );
}

function getOperators(field) {
  if (field?.format === "date") return dateOperators;
  if (field?.format === "number" || field?.key === "amount") return numberOperators;
  return textOperators;
}

function getTemplateOptions(column, directories, counterparties) {
  if (column.key === "contractor" || column.format === "counterparty") return counterparties;
  if (!column.format?.startsWith("directory:")) return [];

  const directoryId = column.format.replace("directory:", "");
  const directory = directories.find((item) => item.id === directoryId && item.saved);

  return (directory?.savedValues || "")
    .split("\n")
    .map((value) => value.trim())
    .filter(Boolean);
}
